module.exports = __webpack_public_path__ + "static/media/scrollDown-fullWidth.f7d82579.gif";